import Vue from 'vue'
import Vuex from 'vuex'
import auth from '../api/auth'
import companyService from '../api/company'
import emailService from '../api/mail'
import ownersService from '../api/owners'
import petsService from '../api/pets'
import examinationService from '../api/examination'
import router from '../router'
import moment from 'moment';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: 'srb',
    isAuthenticated: false,
    IDcompany: null,
    pricePerDateValue: 0,
    pricePerMonthValue: 0,
    printingInProgress: false,
    examinations: null,
    snackbar: {
      value: false,
      color: 'pink',
      text: '',
      timeout: 3000
    },
    languageItemsEn: [
      {
        text: 'English',
        value: 'en'
      },
      {
        text: 'Serbian',
        value: 'srb'
      }
    ],
    languageItemsSrb: [
      {
        text: 'Engleski',
        value: 'en'
      },
      {
        text: 'Srpski',
        value: 'srb'
      }
    ],
    dateRadioChanged: true,
    countToday: 0,
    loading: false,
    searchForm: {
      name: '',
      surname: '',
      mail: '',
      jmbg: '',
      chip: '',
      phone: ''
    },
    myInfoClone: {},
    countByBreed: null,
    petInfo: {
      type: "",
      breed: "",
      name: "",
      gender: "",
      dateOfBirth: "",
      passportNo: "",
      microChipNo: "",
    },
    myInfo: {
      companyId: '',
      companyName: '',
      name: '',
      surname: '',
      email: '',
      pib: '',
      maticni: '',
      phone: '',
      mobilePhone: '',
      logo: '',
      address: ''
    },
    examinationInfo: {
      date: '',
      anamneza: '',
      klinickaSlika: '',
      dijagnoza: '',
      terapija: '',
      price: '',
      specijalneMetodeDijagnostike: '',
      files: [],
      vaccine: {
        vaccineId: null,
        type: '',
        name: '',
        date: null,
        nextDate: null
      }
    },
    ownerInfoCertificate: {},
    ownerInfo: {
      name: '',
      surname: '',
      jmbg: '',
      email: '',
      mobilePhone: '',
      phone: '',
      address: '',
      maticni: 'fali to do'
    },
    ownersResults: [],
    owners: [],
    totalOwnerResult: 0,
    pageSize: 20
  },
  getters: {
    languageItemsList: state => {
      if (state.lang == 'en') {
        return state.languageItemsEn;
      } else {
        return state.languageItemsSrb;
      }
    },
    lang: state => {
      return state.lang;
    },
    rules: state => {
      return {
        required: [
          v => !!v || (state.lang == 'en' ? 'Required' : 'Obavezno polje')
        ],
        length: [
          v => (v && v.length <= 10) || (state.lang == 'en' ? 'Must be less than 10 characters' : 'Mora biti manje od 10 karaktera')
        ],
        email: [
          v => /.+@.+\..+/.test(v) || (state.lang == 'en' ? 'E-mail must be valid' : 'E-mail mora biti validan')
        ]
      }
    },
  },
  mutations: {
    loading: (state, payload) => {
      state.loading = payload
    },
    toast(state, payload) {
      state.snackbar.text = payload.message
      state.snackbar.value = true
      state.snackbar.color = payload.color
    },
    setExaminations (state, payload) {
      state.examinations = payload
    },
    setCountByBreed (state, payload) {
      state.countByBreed = payload
    },
    setPricePerDateValue (state, payload) {
      state.pricePerDateValue = payload
    },
    setPricePerMonthValue (state, payload) {
      state.pricePerMonthValue = payload
    },
    setExaminationInfo (state, payload) {
      var today = null
      state.examinationInfo = {
        date: payload.date,
        anamneza: payload.anamneza,
        klinickaSlika: payload.klinickaSlika,
        napomena: payload.napomena,
        dijagnoza: payload.dijagnoza,
        terapija: payload.terapija,
        price: payload.price ? payload.price.toString() : '',
        specijalneMetodeDijagnostike: payload.specijalneMetodeDijagnostike,
        files: [],
        vaccine: {
          vaccineId: payload.vaccine ? payload.vaccine.vaccineId ? payload.vaccine.vaccineId : null : null,
          type: payload.vaccine ? payload.vaccine.type ? payload.vaccine.type : '' : '',
          name: payload.vaccine ? payload.vaccine.name ? payload.vaccine.name : null : null,
          date: payload.vaccine ? payload.vaccine.date ? moment(payload.vaccine.date).format('YYYY-MM-DD') : today : today,
          nextDate: payload.vaccine ? payload.vaccine.nextDate ?  moment(payload.vaccine.nextDate).format('YYYY-MM-DD') : today : today
        }
      }
      state.dateRadioChanged = !state.dateRadioChanged
    },
    setTotalOwnerResult (state, payload) {
      state.totalOwnerResult = payload
    },
    setMyInfo(state, payload) {
      state.myInfo = {
        companyId: payload.companyId,
        companyName: payload.companyName,
        name: payload.name,
        surname: payload.surname,
        email: payload.email,
        pib: payload.pib,
        maticni: payload.maticni,
        phone: payload.phone,
        mobilePhone: payload.mobilePhone,
        logo: payload.logoFullPath,
        address: payload.address
      }
    },
    setIDcompany(state, payload) {
      state.IDcompany = payload;
    },
    setOwnerInfoCertificate (state, payload) {
      state.ownerInfoCertificate = payload;
    },
    setOwnersResults(state, payload) {
      state.ownersResults = payload;
    },
    setCountToday(state, payload) {
      state.countToday = payload;
    },
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload;
    },
    resetSearchForm(state) {
      state.searchForm.name = ''
      state.searchForm.surname = ''
      state.searchForm.mail = ''
      state.searchForm.jmbg = ''
      state.searchForm.chip = ''
      state.searchForm.phone = ''
    }
  },
  actions: {
    logout(context, payload) {
      context.commit('isAuthenticated', payload);
    },
    getOwnerInfoCertificate: (contex, petID) => {
      contex.commit('loading', true)
      ownersService.getOwnerCertificate(petID)
        .then((response) => {
          contex.commit('setOwnerInfoCertificate', response.data)
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    getOwners: (contex, payload) => {
      contex.commit('loading', true)
      ownersService.getOwners(payload)
        .then((response) => {
          var ownerShowPets = {...response.data.company}
          ownerShowPets.owners.map(x => {
              x.ownerShowPets = false
          })
          contex.commit('setOwnersResults', ownerShowPets.owners)
          contex.commit('setMyInfo', ownerShowPets)
          contex.commit('setTotalOwnerResult', response.data.total)
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    getPriceSumForMonth: (contex, payload) => {
      contex.commit('loading', true)
      companyService.getPriceSumForMonth(payload)
        .then((response) => {
          contex.commit('setPricePerMonthValue', response.data)
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    getPriceSumForDay: (contex, payload) => {
      contex.commit('loading', true)
      companyService.getPriceSumForDay(payload)
        .then((response) => {
          contex.commit('setPricePerDateValue', response.data)
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    sendEmail: (contex, payload) => {
      contex.commit('loading', true)
      emailService.sendEmail(payload)
        .then(() => {
          contex.commit('toast', { message: 'Uspešno poslat mail', color: 'green' })
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    insertOwner: (contex) => {
      contex.commit('loading', true)
      ownersService.insertOwner(contex.state.IDcompany, contex.state.ownerInfo)
        .then(() => {
          router.push('/Dashboard')
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    updateOwner: (contex, idOwner) => {
      contex.commit('loading', true)
      contex.state.ownerInfo.ownerId = parseInt(idOwner)
      ownersService.updateOwner(contex.state.ownerInfo)
        .then(() => {
          router.push('/Dashboard')
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    insertExamination: (contex, payload) => {
      contex.commit('loading', true)
      contex.state.examinationInfo.appointmentId = null
      contex.state.examinationInfo.date = moment().format('YYYY-MM-DD');
      var dateFromVaccine = contex.state.examinationInfo.vaccine.date ? moment(contex.state.examinationInfo.vaccine.date).format('YYYY-MM-DD') : null
      contex.state.examinationInfo.vaccine.date = dateFromVaccine
      var dateToVaccine = contex.state.examinationInfo.vaccine.nextDate ? moment(contex.state.examinationInfo.vaccine.nextDate).format('YYYY-MM-DD') : null
      contex.state.examinationInfo.vaccine.nextDate = dateToVaccine
      contex.state.examinationInfo.files = []
      contex.state.examinationInfo.price = parseInt(contex.state.examinationInfo.price)
      examinationService.insertExamination(payload.petId, contex.state.examinationInfo)
        .then((response) => {
          var appointmentId = response.data
          if (payload.file) {
            var fd = new FormData();
            payload.file.forEach((element) => {
              var fileName = ''
              var splitted = element.name.split('.')
              splitted[splitted.length - 2] = splitted[splitted.length - 2] + '____' + Date.now() + '____'
              splitted = splitted.join('.')
              fileName = splitted
              fd.append("files", element, fileName);
            });
            var obj = {
              file: fd,
              appointmentId: appointmentId
            }
            contex.commit("loading", true);
            contex.dispatch("uploadDocument", obj).then(() => {
              contex.commit("loading", false);
            });
          } else {
            contex.commit("loading", true);
          }
          router.push('/timeline/?petId=' + payload.petId)
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    updateExamination: (contex, payload) => {
      contex.commit('loading', true)
      contex.state.examinationInfo.appointmentId = parseInt(payload.appointmentId)
      contex.state.examinationInfo.date = contex.state.examinationInfo.date != '' ? moment(contex.state.examinationInfo.date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
      var dateFromVaccine = contex.state.examinationInfo.vaccine.date ? moment(contex.state.examinationInfo.vaccine.date).format('YYYY-MM-DD') : null
      contex.state.examinationInfo.vaccine.date = dateFromVaccine
      var dateToVaccine = contex.state.examinationInfo.vaccine.nextDate ? moment(contex.state.examinationInfo.vaccine.nextDate).format('YYYY-MM-DD') : null
      contex.state.examinationInfo.vaccine.nextDate = dateToVaccine
      contex.state.examinationInfo.price = parseInt(contex.state.examinationInfo.price)
      examinationService.updateExamination(contex.state.examinationInfo)
        .then(() => {
          router.push('/timeline/?petId=' + payload.petId)
          contex.commit('toast', { message: 'Uspešno promenjeno', color: 'green' })
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    getExamination: (contex, examinationId) => {
      contex.commit('loading', true)
      examinationService.getExamination(examinationId)
        .then((response) => {
          contex.commit('setExaminationInfo', response.data);
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    getCountByBreed: (contex) => {
      contex.commit('loading', true)
      examinationService.getCountByBreed(contex.state.IDcompany)
        .then((response) => {
          contex.commit('setCountByBreed', response.data);
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    getCountToday: (contex) => {
      contex.commit('loading', true)
      var date = moment().format('YYYY-MM-DD');
      var obj = {
        date: date,
        companyId: contex.state.IDcompany
      }
      companyService.getCountToday(obj)
        .then((response) => {
          contex.commit('setCountToday', response.data)
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    getPet: (contex, payload) => {
      contex.commit('loading', true)
      petsService.getPet(payload)
        .then((response) => {
          var petObj = response.data
          contex.state.petInfo = {
            petId: petObj.petId,
            type: petObj.type,
            breed: petObj.breed,
            name: petObj.name,
            gender: petObj.gender,
            passportNo: petObj.passportNo,
            dateOfBirth: petObj.dateOfBirth,
            microChipNo: petObj.microChipNo,
          };
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    getHistory: (contex, petId) => {
      contex.commit('loading', true)
      petsService.getHistory(petId)
        .then((response) => {
          response.data = response.data.sort((a, b) => new Date(b.date) - new Date(a.date))
          contex.commit('setExaminations', response.data)
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    uploadDocument (contex, payload) {
      return new Promise((resolve, reject) => {
        companyService.upload(payload).then((response) => {
          resolve(response.data)
        }).catch(error => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          reject(error)
        })
      })
    },
    removeExamination (contex, payload) {
      return new Promise((resolve, reject) => {
        examinationService.deleteExamination(payload.appointmentId).then(() => {
          contex.commit('toast', { message: 'Uspešno obrisano', color: 'green' })
          contex.dispatch('getHistory', payload.petId )
        }).catch(error => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          reject(error)
        })
      })
    },
    uploadLogo (contex, payload) {
      return new Promise((resolve, reject) => {
        var obj = {
          companyId: contex.state.IDcompany,
          file: payload
        }
        companyService.uploadLogo(obj).then((response) => {
          resolve(response.data)
        }).catch(error => {
          contex.commit('loading', false)
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          reject(error)
        })
      })
    },
    insertPet: (contex, ownerID) => {
      contex.commit('loading', true)
      contex.state.petInfo.petId = null
      petsService.insertPet(ownerID, contex.state.petInfo)
        .then(() => {
          contex.commit('toast', { message: 'Uspešno dodavanje', color: 'green' })
          router.push('/Dashboard')
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    updatePet: (contex, petId) => {
      contex.commit('loading', true)
      contex.state.petInfo.petId = parseInt(petId)
      petsService.updatePet(contex.state.petInfo)
        .then(() => {
          contex.commit('toast', { message: 'Uspešno promenjeno', color: 'green' })
          router.push('/Dashboard')
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    login: (contex, payload) => {
      contex.commit('loading', true)
      auth.login(payload)
        .then((response) => {
          contex.commit("isAuthenticated", true)
          contex.commit("setIDcompany", response.data)
          router.push('/Dashboard')
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Korisnicko ime ili lozinka je pogrešna!', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    changePassword: (contex, payload) => {
      contex.commit('loading', true)
      auth.changePassword(payload)
        .then(() => {
          router.push('/Dashboard')
          contex.commit('toast', { message: 'Uspešno promenjeno', color: 'green' })
          contex.commit('loading', false)
        }).catch(() => {
          contex.commit('toast', { message: 'Korisnicko ime ili lozinka je pogrešna!', color: '#ff0000' })
          contex.commit('loading', false)
        })
    },
    updateCompany: (contex, payload) => {
      payload.companyId = contex.state.IDcompany
      contex.commit('loading', true)
      companyService.updateCompany(payload)
        .then(() => {
          contex.commit('toast', { message: 'Uspešno promenjeno', color: 'green' })
          contex.commit('loading', false)
        }).catch(() => {
          contex.state.myInfo = {...contex.state.myInfoClone}
          contex.commit('toast', { message: 'Došlo je do greške', color: '#ff0000' })
          contex.commit('loading', false)
        })
    }
  }
})
